import { addCrashReporter } from './.gatsby/gatsbyBrowser/addCrashReporter'

export const wrapRootElement = addCrashReporter
